// Web & Mobile Icons
export const TripIcon = () => (
    <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M6 13.87A4 4 0 0 1 7.41 6a5.11 5.11 0 0 1 1.05-1.54 5 5 0 0 1 7.08 0A5.11 5.11 0 0 1 16.59 6 4 4 0 0 1 18 13.87V21H6Z" stroke="#FF9F1C"/>
        <path d="M6 17h12" stroke="#FFD93D"/>
    </svg>
);

export const DietIcon = () => (
    <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 4c-4 0-7 3-7 7s3 9 7 9 7-5 7-9-3-7-7-7z" stroke="#E53935"/>
        <path d="M12 8.5l.5.5.5-.5.5.5.5-.5.5.5.5-.5" stroke="#E53935"/>
        <path d="M12 11l.5.5.5-.5.5.5.5-.5.5.5.5-.5" stroke="#E53935"/>
        <path d="M10 3.5c0-1 1-2 2-2s2 1 2 2-1 1-2 1-2 0-2-1z" stroke="#4CAF50"/>
        <path d="M11 3.5c-.5.5.5 2 1 2s1.5-1.5 1-2" stroke="#4CAF50"/>
    </svg>
);
export const NewsIcon = () => (
    <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2a8 8 0 0 1 8 8v3a4 4 0 0 1-4 4h-1a4 4 0 0 1-4-4v-3" stroke="#2196F3"/>
        <path d="M4 10a8 8 0 0 1 8-8" stroke="#2196F3"/>
        <path d="M8 21h8" stroke="#2196F3"/>
        <path d="M12 17v4" stroke="#2196F3"/>
    </svg>
);
export const PromotionIcon = () => (
    <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 20H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2z" stroke="#FFC107"/>
        <path d="M12 6v12" stroke="#FFC107"/>
        <path d="M8 10l4-4 4 4" stroke="#FFC107"/>
    </svg>
);

// IDE Icons
export const ExplainIcon = () => (
    <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="#9C27B0"/>
        <path d="M14 2v6h6" stroke="#9C27B0"/>
        <path d="M12 18v-6" stroke="#9C27B0"/>
        <circle cx="12" cy="9" r="1" stroke="#9C27B0"/>
    </svg>
);

export const RefactorIcon = () => (
    <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 3a2.85 2.85 0 1 1 0 5.7" stroke="#00BCD4"/>
        <path d="M7 21a2.85 2.85 0 1 1 0-5.7" stroke="#00BCD4"/>
        <path d="M17 6v12" stroke="#00BCD4"/>
        <path d="M7 6v12" stroke="#00BCD4"/>
    </svg>
);

export const ErrorIcon = () => (
    <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" stroke="#F44336"/>
        <line x1="12" y1="8" x2="12" y2="12" stroke="#F44336"/>
        <line x1="12" y1="16" x2="12" y2="16" stroke="#F44336"/>
    </svg>
);

export const OptimizeIcon = () => (
    <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 20V10" stroke="#4CAF50"/>
        <path d="M12 20V4" stroke="#4CAF50"/>
        <path d="M6 20v-6" stroke="#4CAF50"/>
    </svg>
);

// Chrome Icons
export const SummaryIcon = () => (
    <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="#3F51B5"/>
        <path d="M14 2v6h6" stroke="#3F51B5"/>
        <line x1="8" y1="13" x2="16" y2="13" stroke="#3F51B5"/>
        <line x1="8" y1="17" x2="16" y2="17" stroke="#3F51B5"/>
        <line x1="8" y1="9" x2="16" y2="9" stroke="#3F51B5"/>
    </svg>
);

export const FactCheckIcon = () => (
    <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 11l3 3L22 4" stroke="#8BC34A"/>
        <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" stroke="#8BC34A"/>
    </svg>
);

export const FillIcon = () => (
    <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2v20" stroke="#FF5722"/>
        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" stroke="#FF5722"/>
    </svg>
);

export const WhatIsIcon = () => (
    <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" stroke="#607D8B"/>
        <path d="M12 16v-4" stroke="#607D8B"/>
        <path d="M12 8h.01" stroke="#607D8B"/>
    </svg>
);
